import _ from 'lodash';
import { TextField } from '@material-ui/core';
import Text from 'components/base/Text';
import HideShowCopyTextField from 'components/HideShowCopyTextField/HideShowCopyTextField';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { createCreateApiTokenModal } from 'modals/modal-options-factory';
import AppRouter from 'common/AppRouter';
import { useHistory } from 'react-router';
import { LBButton, LBLabel, LBRadioGroupItem } from '@linearb/buzz';

const StyledRadio = styled.div`
  margin-top: -0.2rem;
  width: 86.4rem;
`;

const TokenTextWrapper = styled.div`
  color: ${getColor('shuttleGray')};
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 1.2rem;
  cursor: default;

  p > span {
    color: ${getColor('chambray')};
    cursor: pointer;
  }
`;

const getTokenPrefix = ({ api_token_id: apiTokenId, apiTokens }) => {
  const selectedToken = apiTokens.find(item => item.id === apiTokenId);
  return _.get(selectedToken, 'prefix', '');
};

const RadioOption = ({
  radioOption,
  selectedRadio,
  handleRadioChange,
  handleValueChange,
  textValue = '',
  isAdminAccount,
  toggleModal,
  apiTokens,
  toggleSnackBar,
  setApiTokens,
  tokenExists,
  optionBlocked,
  onTokenGenerated,
  account,
  value,
  disabled = false
}) => {
  const history = useHistory();
  const isTextField = radioOption.input === 'isArray';
  const isShowTokenField =
    radioOption.withApiToken && radioOption.radio_value === selectedRadio;
  const blockedMessage = optionBlocked && _.get(radioOption, 'blockedMessage');
  const shouldShowRadio = !!(tokenExists && isShowTokenField && isAdminAccount);
  const isDisabled = optionBlocked || disabled;

  return (
    <div className='flex flex-row gap-2'>
      <LBRadioGroupItem
        key={radioOption.radio_value}
        data-testid={`radio-button-${radioOption.radio_value}`}
        data-cy={`radio-button-${radioOption.radio_value}-data-cy`}
        id={radioOption.radio_value}
        value={radioOption.radio_value}
        disabled={isDisabled}
      />
      <LBLabel htmlFor={radioOption.radio_value}>
        <StyledRadio isTextField={isTextField} id='radio-options'>
          <Text
            lineHeight={1.7}
            size='large'
            color={isDisabled ? 'osloGray' : 'darkGray'}
            weight='bold'
            dangerouslySetInnerHTML={{ __html: radioOption.label }}
          />
          <Text
            lineHeight={1.7}
            size='large'
            color={isDisabled ? 'osloGray' : 'darkGray'}
            dangerouslySetInnerHTML={{ __html: radioOption.subtext }}
          />
          {isTextField && (
            <TextField
              inputProps={{
                style: { fontSize: 15 },
                'data-testid': `text-field-input-${radioOption.radio_value}`,
                'data-cy': `text-field-input-${radioOption.radio_value}-data-cy`
              }}
              variant='outlined'
              data-testid={`text-field-${radioOption.radio_value}`}
              onChange={handleValueChange}
              value={textValue}
              placeholder={radioOption.hint}
              disabled={selectedRadio !== radioOption.radio_value}
              focused={selectedRadio === radioOption.radio_value}
            />
          )}
          {isShowTokenField &&
            ((tokenExists && (
              <HideShowCopyTextField
                initiallyVisible={false}
                showVisibilityToggle={false}
                showCopy={false}
                stringLength={32}
                hiddenCharacter={'&middot;'}
                hiddenPrefix={getTokenPrefix({
                  api_token_id: _.get(value, 'api_token_id'),
                  apiTokens
                })}
              />
            )) ||
              (isAdminAccount && (
                <LBButton
                  data-testid='create-api-token-button'
                  data-cy='create-api-token-button-data-cy'
                  onClick={() => {
                    toggleModal(
                      createCreateApiTokenModal({
                        showGoToSettingsMessage: true,
                        apiTokens,
                        toggleModal,
                        toggleSnackBar,
                        setApiTokens,
                        onTokenGenerated,
                        account,
                        onGoToSettingsClicked: () => {
                          toggleModal();
                          history.push(
                            `${AppRouter.API_TOKENS.path}?isOrgSettings=true`
                          );
                        },
                        onCancel: () => toggleModal()
                      })
                    );
                  }}
                >
                  Create API Token
                </LBButton>
              )))}
          {shouldShowRadio && (
            <TokenTextWrapper>
              <Text data-testid='revoke-token-in-settings-label' size='medium'>
                to revoke a token go to{' '}
                <span
                  data-testid='revoke-token-in-settings-label-clickable'
                  onClick={() => {
                    history.push(
                      `${AppRouter.API_TOKENS.path}?isOrgSettings=true`
                    );
                  }}
                >
                  settings / API tokens
                </span>
              </Text>
            </TokenTextWrapper>
          )}
          {blockedMessage && (
            <Text size='medium' color='torchRed'>
              {blockedMessage}
            </Text>
          )}
        </StyledRadio>
      </LBLabel>
    </div>
  );
};

export default RadioOption;
